'use client';

import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';

const GTMProvider: React.FC<{ children: React.ReactNode; gtmId: string }> = ({ children, gtmId }) => {
  useEffect(() => {
    if (gtmId) {
      TagManager.initialize({ gtmId });
    } else {
      console.warn('GTM ID is not defined in environment variables.');
    }
  }, [gtmId]);

  return <React.Fragment>{children}</React.Fragment>;
};

export default GTMProvider;
